<div class="container">
  <h3>
    {{ '+INSTALLATIONS.INSTALLATION.ERROR_LIST.ACTIVE_ERROR_INFORMATION.ECU' | translate }}
  </h3>

  <mat-spinner *ngIf="dataAtTheTimeOfFaultDetectionLoading$ | async; else showData"></mat-spinner>

  <ng-template #showData>
    <div
      *ngIf="dataAtTheTimeOfFaultDetectionError$ | async; else showValue"
      class="warning-box flex flex-row gap-[12px] justify-start items-center"
    >
      <div>
        {{ '+ACTIVE_ERROR_DETAILS_PAGE.WARNING_BOX.FAILED.HEADER' | translate }}
      </div>
      <app-pill [type]="pillType.brand">
        {{ '+ACTIVE_ERROR_DETAILS_PAGE.WARNING_BOX.FAILED.CHIP_HEADER' | translate }}
      </app-pill>
    </div>
    <ng-template #showValue>
      {{ 'TI_' + (logicalLinkOfSelectedActiveError$ | async) | translate }}
    </ng-template>
  </ng-template>
</div>
